<template>
  <div class="dr-biz-search" :style="{ maxWidth: width + 'px' }">
    <el-input v-model="keyword" :placeholder="placeholder" clearable @keyup.enter.native="submit" />
    <el-button type="primary" class="dr-biz-search__btn" @click="submit">{{ buttonText || $t('message.home.搜索') }}</el-button>
  </div>
</template>

<script>
/**
 * 装修业务组件：搜索框
 * 输入关键词 → 跳 /searchGoods?keyword=xxx
 */
export default {
  name: 'DrSearchBox',
  props: {
    placeholder: { type: String, default: '请输入关键词' },
    buttonText: { type: String, default: '' },
    width: { type: Number, default: 400 }
  },
  data() {
    return { keyword: '' }
  },
  methods: {
    submit() {
      const kw = (this.keyword || '').trim()
      const query = kw ? { keyword: JSON.stringify(kw) } : {}
      const path = '/searchGoods'
      if (this.$route.path === path && String(this.$route.query.keyword || '') === String(query.keyword || '')) {
        return
      }
      const nav = this.$route.path === path
        ? this.$router.replace({ path, query })
        : this.$router.push({ path, query })
      if (nav && typeof nav.catch === 'function') {
        nav.catch(err => { if (err && err.name !== 'NavigationDuplicated') throw err })
      }
    }
  }
}
</script>

<style scoped>
.dr-biz-search { display: inline-flex; align-items: center; gap: 8px; width: 100%; }
.dr-biz-search .el-input { flex: 1; }
.dr-biz-search__btn { background: var(--theme-primary, #4d6bfe); border-color: var(--theme-primary, #4d6bfe); }
</style>
